import styles from "./analytics-cards.module.css";

export default function SupplierBalances({ balances }) {
  return (
    <div className={styles.card}>
      <h3>Supplier Balances</h3>
      <div className={styles.supplierList}>
        {Object.entries(balances || {})?.map(([key, value]) => (
          <div key={key} className={styles.supplierItem}>
            <span className={styles.supplierName}>{key}</span>
            <span className={styles.supplierBalance}>
              ₹{value.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
